export const FETCH_USERS_SUCCESS = 'fetch_users_success'
export const FETCH_USER_DETAILS_SUCCESS = 'fetch_user_details_success'
export const UPDATE_USER_SUCCESS = 'update_user_success'
export const UPDATE_USERS_SUCCESS = 'update_users_success'
export const CREATE_USER_SUCCESS = 'create_user_success'
